import * as TabsPrimitive from "@radix-ui/react-tabs";
import { cn } from "~/lib/utils";

function Tabs({ className, ...props }: React.ComponentProps<typeof TabsPrimitive.Root>) {
  return <TabsPrimitive.Root className={className} {...props} />;
}

function TabsList({ className, ...props }: React.ComponentProps<typeof TabsPrimitive.List>) {
  return <TabsPrimitive.List className={cn("flex border-b border-border -mx-5 px-5", className)} {...props} />;
}

function TabsTrigger({ className, ...props }: React.ComponentProps<typeof TabsPrimitive.Trigger>) {
  return (
    <TabsPrimitive.Trigger
      className={cn(
        "relative flex-1 py-2.5 text-sm font-medium transition-colors cursor-pointer",
        "text-muted-foreground hover:text-foreground",
        "data-[state=active]:text-foreground",
        "after:absolute after:bottom-0 after:left-1/2 after:-translate-x-1/2 after:h-[3px] after:max-w-24 after:w-full after:rounded-t-full",
        "after:scale-x-0 data-[state=active]:after:scale-x-100 after:transition-transform",
        "data-[state=active]:after:bg-primary",
        className,
      )}
      {...props}
    />
  );
}

function TabsContent({ className, ...props }: React.ComponentProps<typeof TabsPrimitive.Content>) {
  return <TabsPrimitive.Content className={cn("pt-4", className)} {...props} />;
}

export { Tabs, TabsList, TabsTrigger, TabsContent };
